"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_REQUEST = 'extensions/UPDATE/REQUEST';
exports.UPDATE_SUCCESS = 'extensions/UPDATE/SUCCESS';
exports.UPDATE_FAILURE = 'extensions/UPDATE/FAILURE';
//# sourceMappingURL=types.js.map